// @ts-expect-error throttle-debounce types mismatch with current TS config
import { throttle } from 'throttle-debounce';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import { YA_METRIC_ID } from '~/constants';
import { percentageInit, viewedPagePercent, getPageObject } from '~/utils/percentagePage';

export default defineNuxtPlugin({
  dependsOn: ['data-layer'],
  async setup() {
    const { $sendYandexMetrika, $logger } = useNuxtApp();
    const log = $logger.withScope('🎡 scroll-page-plugin');

    const throttledOnScroll = throttle(100, onScroll);

    percentageInit();

    log('add listener');
    window.addEventListener('scroll', throttledOnScroll);

    function onScroll(): void {
      const pagePercent = viewedPagePercent();
      log('onScroll', pagePercent);

      if (pagePercent) {
        percentageSendAnalytics(getPageObject(), pagePercent);
      }
    }

    function percentageSendAnalytics(
      typeCategory: { thresholds: Record<string, boolean> },
      newValue: number,
    ) {
      const { thresholds } = typeCategory;

      const viewedThresholds = Object.keys(thresholds)
        .map(Number)
        .filter((threshold) => threshold <= newValue && !thresholds[threshold]);

      viewedThresholds.forEach((threshold) => {
        thresholds[threshold] = true;

        const scrollEventParams = {
          page: {
            event: 'скролл страницы %',
            value: threshold.toString(),
          },
        };

        log('sendAnalytics', scrollEventParams);
        window.ym(YA_METRIC_ID, 'params', scrollEventParams);

        $sendYandexMetrika({
          level1: 'Скролл Страницы',
          level4: threshold.toString(),
        });

        trackSelfDescribingEvent({
          event: {
            schema: 'iglu:dev.snowplow.simple/custom_data/jsonschema/1-0-0',
            data: { pageScroll: threshold.toString() },
          },
        });
      });
    }
  },
});
